import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SliderBox } from '../../../molecules/slider-box';
import { useSelector } from '../../../store/utils';

export const SettingsPvNominal = () => {
  const largeInstallation = useSelector((s) => s.variables.LARGE_INSTALLATION);

  return (
    <SliderBox
      title={
        <FormattedMessage
          id="settings.photovoltaics.nominal"
          defaultMessage="Nominální výkon v panelech celé elektrárny"
        />
      }
      variableId="PV_NOMINAL"
      visibility={{ variableId: 'PV_INSTALL' }}
      opts={{
        style: 'unit',
        unit: 'kilowatt-peak',
        maximumFractionDigits: 0,
      }}
      min={0.5}
      max={largeInstallation ? 2000 : 100}
      step={1}
    />
  );
};
